import EntityList from "../entity_list/EntityList";

const BxunitateList = () => {
  return (
    <EntityList
      entityName="Bxunitate"
      fields={["denumire"]}
      apiUrl="http://localhost:8000/bxunitate"
    />
  );
};

export default BxunitateList;
